// extracted by mini-css-extract-plugin
export default {"viewerframe":"Pg_2_3_viewerframe__kQCxa","content":"Pg_2_3_content__0CZyt"};